'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { HTMLAttributeAnchorTarget, MouseEvent } from 'react';
import { isQuery } from '@/src/utils/helpers/isQuery';

type Props = {
  href: string;
  target?: HTMLAttributeAnchorTarget;
  children?: React.ReactNode;
  event: object;
  className?: string;
  passHref?: boolean;
  rel?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>) => void;
  title?: string;
};
function CSRLink(props: Readonly<Props>) {
  const router = useRouter();
  const hasQuery = isQuery(props.href);
  const { href, target, passHref, className, children, rel, onClick: propOnClick, ...rest } = props;
  return (
    <Link
      onClick={(e) => {
        propOnClick?.(e);
        if (e.defaultPrevented) return;
        e.preventDefault();
        const dataLayer = (window && 'dataLayer' in window && (window.dataLayer as any[])) || null;
        dataLayer?.push(props.event);
        router.push(props.href);
      }}
      className={className}
      href={href}
      target={target ?? '_self'}
      rel={rel ?? (hasQuery ? 'nofollow' : undefined)}
      passHref={passHref}
      {...rest}
    >
      {children}
    </Link>
  );
}
export default CSRLink;
